import gql from 'graphql-tag';

const ADD_ROLE = gql`
  mutation(
    $name: String
    $description: String
    $roleType: RoleTypeInput
    $roleFeatureList: [RoleFeatureInput]
    $addUserList: [UserInput]
  ) {
    addRole(
      input: {
        name: $name
        description: $description
        roleType: $roleType
        roleFeatureList: $roleFeatureList
        addUserList: $addUserList
      }
    ) {
      roleId
      name
      description
    }
  }
`;

const UPDATE_ROLE = gql`
  mutation(
    $roleId: ID
    $name: String
    $description: String
    $roleType: RoleTypeInput
    $roleFeatureList: [RoleFeatureInput]
    $addUserList: [UserInput]
    $deleteUserList: [UserInput]
  ) {
    updateRole(
      input: {
        roleId: $roleId
        name: $name
        description: $description
        roleType: $roleType
        roleFeatureList: $roleFeatureList
        addUserList: $addUserList
        deleteUserList: $deleteUserList
      }
    ) {
      roleId
      name
      description
      roleFeatureList {
        feature {
          featureId
        }
        operationList {
          operationId
          name
          value
        }
      }
      roleUserList {
        userId
        firstName
        lastName
        email
      }
    }
  }
`;

const UPDATE_ROLE_PERMISSION = gql`
  mutation(
    $roleId: ID
    $roleType: RoleTypeInput
    $roleFeatureList: [RoleFeatureInput]
  ) {
    updateRolePermissions(
      input: {
        roleId: $roleId
        roleType: $roleType
        roleFeatureList: $roleFeatureList
      }
    ) {
      roleId
      roleType {
        roleTypeId
        name
      }
      roleFeatureList {
        feature {
          featureId
        }
        operationList {
          operationId
          name
          value
        }
      }
    }
  }
`;

const UPDATE_ROLE_USERS = gql`
  mutation(
    $roleId: ID
    $roleType: RoleTypeInput
    $addUserList: [UserInput]
    $deleteUserList: [UserInput]
  ) {
    updateRoleUsers(
      input: {
        roleId: $roleId
        roleType: $roleType
        addUserList: $addUserList
        deleteUserList: $deleteUserList
      }
    ) {
      roleId
    }
  }
`;

const DELETE_ROLE = gql`
  mutation($roleId: ID!) {
    deleteRole(roleId: $roleId)
  }
`;

const GET_ROLES = gql`
  query {
    getRoles {
      roleId
      name
      description
      editable
      creationType
      roleType {
        roleTypeId
        name
      }
      roleFeatureList {
        feature {
          featureId
        }
        operationList {
          operationId
          name
          value
        }
      }
    }
  }
`;

const GET_TECHNICIAN_ROLES = gql`
  query {
    getTechnicianRoleTypeRoles {
      roleId
      name
      description
      editable
      creationType
      roleType {
        roleTypeId
        name
      }
      roleFeatureList {
        feature {
          featureId
          labelKey
        }
        operationList {
          operationId
          name
          value
          labelKey
        }
      }
    }
  }
`;

const GET_REQUESTER_ROLES = gql`
  query {
    getUserRoleTypeRoles {
      roleId
      name
      description
      editable
      creationType
      roleType {
        roleTypeId
        name
      }
      roleFeatureList {
        feature {
          featureId
        }
        operationList {
          operationId
          name
          value
        }
      }
    }
  }
`;

const GET_ROLE_PERMISSON = gql`
  query getRolePermissions($roleId: ID!) {
    getRolePermissions(roleId: $roleId) {
      roleId
      roleFeatureList {
        feature {
          featureId
          name
          key
        }
        operationList {
          operationId
          name
          value
        }
      }
    }
  }
`;

const GET_ROLE_USERLIST = gql`
  query getRoleUsers($roleId: ID!) {
    getRoleUsers(roleId: $roleId) {
      roleId
      roleUserList {
        userId
        firstName
        lastName
        email
        associations {
          id
          client {
            accountId
            name
          }
        }
        account {
          accountType
          name
          accountId
        }
      }
    }
  }
`;

const GET_ROLES_TYPE_DETAIL = gql`
  query {
    getRoleTypeDetails {
      roleTypeId
      name
      roleTypeFeatureList {
        feature {
          featureId
          name
          labelKey
          permissionCategory {
            name
            permissionCategoryId
            labelKey
          }
          key
        }
        operationList {
          operationId
          name
          value
          labelKey
        }
      }
    }
  }
`;

const GET_MSP_ROLE_FEATURES = gql`
  query {
    getFeatures {
      featureId
      name
      permissionCategory {
        name
        permissionCategoryId
      }
    }
  }
`;

const GET_USER_ROLE_TYPES = gql`
  query {
    getUserRoleTypeRoles {
      roleId
      name
    }
  }
`;

const GET_ROLE_DEPENDENCIES = gql`
  query getRoleFeatureDependencies($roleTypeId: Int) {
    getRoleFeatureDependencies(roleTypeId: $roleTypeId)
  }
`;

const GET_TECHNICIAN_ROLES_FOR_DROPDOWN = gql`
  query {
    getTechnicianRoleTypeRoles {
      roleId
      name
    }
  }
`;

export {
  UPDATE_ROLE_USERS,
  GET_ROLE_PERMISSON,
  GET_ROLE_USERLIST,
  UPDATE_ROLE_PERMISSION,
  ADD_ROLE,
  UPDATE_ROLE,
  GET_ROLES,
  GET_TECHNICIAN_ROLES,
  GET_REQUESTER_ROLES,
  GET_ROLES_TYPE_DETAIL,
  GET_MSP_ROLE_FEATURES,
  GET_USER_ROLE_TYPES,
  DELETE_ROLE,
  GET_ROLE_DEPENDENCIES,
  GET_TECHNICIAN_ROLES_FOR_DROPDOWN
};
